<template>
    <navbar v-model="showNavbar">
        <div class="navbar-wrapper">
            <div class="navbar-minimize">
                <button id="minimizeSidebar" class="btn btn-icon btn-round navbar-icon" @click="minimizeSidebar">
                    <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
                    <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
                </button>
            </div>
            <div class="navbar-toggle">
                <navbar-toggle-button @click.native="toggleSidebar">
                </navbar-toggle-button>
            </div>
            <a class="navbar-brand" href="#pablo">{{ appName }}</a>
        </div>

        <template slot="navbar-menu">
            <ul class="navbar-nav navbar-all-nav">
                <!-- <li><LocaleSwitcher /></li> -->
                <li class="nav-icon-item">
                    <div class="notification-icon-wrapper">
                        <div v-if="notificationCount!=='0'" class="notification-red-badge">{{
                                notificationCount
                            }}
                        </div>
                        <a class="nav-link nav-icon ti-bell" title="Notifications"
                           @click="userNotificationsPage"></a>
                    </div>
                </li>
                <li class="nav-icon-item">
                    <a class="nav-link nav-icon ti-help" title="Need help?" href="#"
                       @click="showHelpModal()"></a>
                </li>
                <li class="nav-icon-item">
                    <a class="nav-link nav-icon ti-flag-alt" title="Report an Issue"
                       @click="showReportIssueModal()"></a>
                </li>
                <!--                <div class="photo" v-if="usertype=='admin'"><img :src="adminImage" height="40px"/></div>
                                <div class="photo" v-if="usertype=='user'"><img :src="userImage" height="40px"/></div>-->
                <drop-down icon="nc-icon nc-bell-55" tag="li" position="right" direction="none"
                           class="nav-item dropdown user-dropdown">
                    <a slot="title" slot-scope="{isOpen}" class="nav-link dropdown-toggle dropdown-toggle-name user-dropdown-toggle"
                       aria-haspopup="true" :aria-expanded="isOpen">
                        <span class="user-name-wrapper">
                            <span class="user-avatar">{{ getUserInitials() }}</span>
                            <span class="user-name" :title="username">{{ username }}</span>
                            <i class="dropdown-caret" :class="{'rotated': isOpen}"></i>
                        </span>
                    </a>
                    <a class="dropdown-item modern-dropdown-item" @click="userProfilePage">
                        <i class="ti-user dropdown-item-icon"></i>
                        <span class="sidebar-normal">My Profile</span>
                    </a>

                    <a class="dropdown-item modern-dropdown-item" @click="userOrganisationPage" v-if="usertype=='user'">
                        <i class="ti-settings dropdown-item-icon"></i>
                        <span class="sidebar-normal">Organisation Settings</span>
                    </a>

                    <div class="dropdown-divider"></div>

                    <div class="site-zoom-control">
                        <site-zoom-control></site-zoom-control>
                    </div>
                    
                    <div class="dropdown-divider"></div>

                    <router-link to="" tag="a">
                        <a class="dropdown-item modern-dropdown-item logout-item" @click="logout()">
                            <i class="ti-power-off dropdown-item-icon"></i>
                            <span class="sidebar-normal">Logout</span>
                        </a>
                    </router-link>
                </drop-down>

            </ul>

        </template>
        <div class="type-header" style="text-align: center;">
            <span><img height="35" width="35" style="margin-right: 10px; object-fit: cover;"
                       :src="getOrganisationLogoURL"/> </span>
            <span>{{ getTitle }}</span>
        </div>
        <help-modal ref="helpModal2"></help-modal>
        <report-issue-modal ref="reportIssueModal"></report-issue-modal>
    </navbar>
</template>
<script>
import {Navbar, NavbarToggleButton, SiteZoomControl} from '../UIComponents';
import HelpModal from "./HelpModal.vue";
import ReportIssueModal from "./ReportIssueModal.vue";
import LocaleSwitcher from "../../LocaleSwitcher.vue"

export default {
    components: {
        Navbar,
        NavbarToggleButton,
        "help-modal": HelpModal,
        "report-issue-modal": ReportIssueModal,
        LocaleSwitcher,
        SiteZoomControl
    },
    data() {
        return {
            username: '',
            activeNotifications: false,
            showNavbar: false,
            projectType: "",
            userImage: '',
            notificationCount: '0',
            notificationCheckTimer: null,
        };
    },
    props: {
        usertype: {
            type: String,
        }
    },
    methods: {
        getUserInitials() {
            if (!this.username) return '';
            const names = this.username.trim().split(' ');
            if (names.length >= 2) {
                return (names[0][0] + names[names.length - 1][0]).toUpperCase();
            }
            return names[0].substring(0, 2).toUpperCase();
        },
        userProfilePage() {
            this.$router.push({'name': 'userProfile',});
        },
        userOrganisationPage() {
            this.$router.push({'name': 'organisationSettings',});
        },
        userNotificationsPage() {
            //this.$router.push({'name': 'userNotifications',});
            window.Bus.$emit('open-notification-panel')
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications;
        },
        closeDropDown() {
            this.activeNotifications = false;
        },
        toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        hideSidebar() {
            this.$sidebar.displaySidebar(false);
        },
        minimizeSidebar() {
            let href = location.href;
            if (href.indexOf('record_detail_list') > -1) {
                if (document.querySelector('body').getAttribute('class').indexOf('sidebar-mini') >= 0) {
                    document.querySelectorAll('.project_name')[0].style.fontSize = "1.57em";
                    document.querySelectorAll('.img_fix_size')[0].style.height = "100px";
                } else {
                    document.querySelectorAll('.project_name')[0].style.fontSize = "13px";
                    document.querySelectorAll('.img_fix_size')[0].style.height = "60px";
                }
            }
            document.querySelectorAll('.sidebar')[0].style.zIndex = "1";
            this.$sidebar.toggleMinimize();
        },
        toggleNavbar() {
            this.showNavbar = !this.showNavbar;
        },
        sidebarSetProjectNameImg() {
            let sidebar = document.querySelectorAll(".sidebar")[0];
            sidebar.onmouseover = (event => {
                if (document.querySelector('body').getAttribute('class').indexOf('sidebar-mini') >= 0) {
                    document.querySelectorAll('.project_name')[0].style.fontSize = "1.57em";
                    document.querySelectorAll('.img_fix_size')[0].style.height = "100px";
                    document.querySelectorAll('.sidebar')[0].style.zIndex = "1030";
                }
            });
            sidebar.onmouseout = (event => {
                if (document.querySelector('body').getAttribute('class').indexOf('sidebar-mini') >= 0) {
                    document.querySelectorAll('.project_name')[0].style.fontSize = "13px";
                    document.querySelectorAll('.img_fix_size')[0].style.height = "60px";
                    document.querySelectorAll('.sidebar')[0].style.zIndex = "1";
                }
            });
        },
        sidebarMenuIcon() {
            let sidebar = document.querySelectorAll(".sidebar")[0];
            let href = location.href;
            sidebar.onmouseover = (event => {
                if (this.$sidebar.isMinimized) {
                    document.querySelectorAll(".navbar-icon")[0].style.setProperty("margin-left", "130px", "important");
                }
                if (href.indexOf('record_detail_list') > -1) {
                    if (document.querySelector('body').getAttribute('class').indexOf('sidebar-mini') >= 0) {
                        document.querySelectorAll('.project_name')[0].style.fontSize = "1.57em";
                        document.querySelectorAll('.img_fix_size')[0].style.height = "100px";
                    }
                }
            });
            sidebar.onmouseout = (event => {
                if (this.$sidebar.isMinimized) {
                    document.querySelectorAll(".navbar-icon")[0].style.setProperty("margin-left", "-50px", "important");
                }
                if (href.indexOf('record_detail_list') > -1) {
                    if (document.querySelector('body').getAttribute('class').indexOf('sidebar-mini') >= 0) {
                        document.querySelectorAll('.project_name')[0].style.fontSize = "13px";
                        document.querySelectorAll('.img_fix_size')[0].style.height = "60px";
                    }
                }
            });
        },
        projectDetails(projectId) {
            axios.get("/project/details", {
                params: {
                    project_id: projectId,
                }
            })
                .then(response => {
                    var project = response.data.response.data.project;
                    this.projectType = project.type;
                })
                .catch(error => {
                });
        },
        async logout() {
            await this.$store.dispatch('LogOut');
        },
        notifications() {
            let vm = this;
            axios.get('user/notifications').then(response => {
                if (response.data.response.error.error_code == 0) {
                    vm.notificationCount = response.data.response.data.unread_count;
                }
            }).catch(error => {
                console.log(error)
            });
        },
        showHelpModal() {
            this.$refs.helpModal2.loadUrl(window.USER_MANUAL_URL);
        },
        showReportIssueModal() {
            this.$refs.reportIssueModal.openModal();
        }
    },
    computed: {
        getTitle() {
            return this.$store.getters.getProjectNavBarTitle;
        },
        getOrganisationLogoURL() {
            return this.$store.getters.getOrganisationLogoUrl;
        },
        appName() {
            return window.AppName;
        },
        adminImage() {
            if (this.$props.userimage == null) {
                return window.DefaultUserImage;
            } else {
                if (this.$props.userimage == '') {
                    return window.DefaultUserImage;
                }
                return this.$props.userimage;
            }
        },
        logo() {
            return "https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/104/HSI-logo.png?v=1503710412000";
        },
        title() {
            return window.appConfig.appName || {};
        },
    },
    created() {
        let vm = this;
        vm.notifications();

        vm.notificationCheckTimer = setInterval(() => {
            vm.notifications();
        }, 1000 * 60)

        var userData = JSON.parse(localStorage.getItem('userdata'));
        vm.username = userData.userName;
        var user_image = userData.userImage;
        if (user_image == null || user_image == '') {
            vm.userImage = window.DefaultUserImage;
        } else {
            vm.userImage = user_image;
        }

        //vm.sidebarMenuIcon();

        this.helpLinkUrl = window.USER_MANUAL_URL;
        /*Bus.$emit("projecNavbar", 1);
        let href = location.href;
        if (href.indexOf('record_detail_list') > -1) {
            this.$sidebar.toggleMinimize();
            document.querySelectorAll('.project_name')[0].style.fontSize = "13px";
            document.querySelectorAll('.img_fix_size')[0].style.height = "60px";
        }
        document.querySelectorAll('.sidebar')[0].style.zIndex = "1";
        let url = location.href;
        let project = vm.$store.getters.getCurrentSelectedProject;
        if (href.indexOf('edit_area') > -1 || href.indexOf('area_details') > -1) {
            this.projectType = "MV";
        } else {
            this.projectDetails(project.id);
        }

        vm.$forceUpdate();*/
    },
    beforeDestroy() {
        clearInterval(this.notificationCheckTimer)
    }
};

</script>
<style lang="scss" scoped>
/* Navbar Icon Improvements */
.navbar-nav.navbar-all-nav {
    display: flex;
    align-items: center;
}

.nav-icon-item {
    margin: 0 8px;
    display: flex;
    align-items: center;
}

.nav-icon {
    font-size: 22px !important;
    cursor: pointer;
    color: #66615B;
    transition: all 0.3s ease;
    padding: 10px !important;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.nav-icon:hover {
    color: #1e88e5;
    background-color: rgba(30, 136, 229, 0.08);
    transform: scale(1.05);
}

/* User Avatar */
.user-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #1e88e5;
    color: white;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
    margin-right: 8px;
    letter-spacing: 0.5px;
}

.user-name-wrapper {
    display: flex;
    align-items: center;
    padding: 6px 12px;
    border-radius: 24px;
    transition: all 0.3s ease;
}

.user-name-wrapper:hover {
    background-color: rgba(102, 97, 91, 0.05);
}

.user-dropdown-toggle {
    color: #66615B !important;
}

.user-dropdown {
    display: flex;
    align-items: center;
}

.dropdown-caret {
    display: inline-block;
    margin-left: 8px;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid #66615B;
    transition: transform 0.3s ease;
}

.dropdown-caret.rotated {
    transform: rotate(180deg);
}

/* Modern Dropdown Styling */
.user-dropdown .dropdown-menu {
    border-radius: 12px !important;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12) !important;
    border: 1px solid rgba(0, 0, 0, 0.05) !important;
    padding: 8px 0 !important;
    min-width: 280px;
    margin-top: 8px !important;
    overflow: hidden;
}

.user-dropdown .dropdown-menu .dropdown-item-link {
    text-decoration: none !important;
}

.user-dropdown .dropdown-menu .dropdown-item-link:hover {
    text-decoration: none !important;
}

.user-dropdown .dropdown-menu a {
    text-decoration: none !important;
}

.user-dropdown .dropdown-menu a:hover {
    text-decoration: none !important;
}

.modern-dropdown-item {
    display: flex !important;
    align-items: center;
    padding: 12px 20px !important;
    transition: all 0.2s ease !important;
    color: #333 !important;
    font-size: 14px;
    border-radius: 0 !important;
    cursor: pointer;
    text-decoration: none !important;
}

.modern-dropdown-item .sidebar-normal {
    color: #333 !important;
}

.modern-dropdown-item:hover {
    background-color: rgba(30, 136, 229, 0.08) !important;
    color: #1e88e5 !important;
    text-decoration: none !important;
}

.modern-dropdown-item:hover .dropdown-item-icon {
    color: #1e88e5;
}

.modern-dropdown-item:hover .sidebar-normal {
    color: #1e88e5 !important;
}

.dropdown-item-icon {
    margin-right: 12px;
    font-size: 18px;
    width: 20px;
    min-width: 20px;
    color: #66615B;
    transition: color 0.2s ease;
    transform: rotate(0deg) !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.logout-item:hover {
    background-color: rgba(244, 67, 54, 0.08) !important;
    color: #f44336 !important;
}

.logout-item:hover .dropdown-item-icon {
    color: #f44336;
}

.logout-item:hover .sidebar-normal {
    color: #f44336 !important;
}

.dropdown-divider {
    margin: 8px 0;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.site-zoom-control {
    padding: 16px 20px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    background-color: rgba(0, 0, 0, 0.02);
}

.type-header {
    text-align: center;
    font-size: 17px;
    font-weight: 600;
    color: black;
}
@media screen and (max-width: 991px) {
    span{
        &:last-child{
            max-width: 110px;
            white-space: pre;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: middle;
            font-size: 16px;
        }
    }
}
@media (min-width: 1024px) {
    .type-header {
        width: 50%;
    }
}

@media (min-width: 1366px) {
    .type-header {
        width: 65%;
    }
}

@media (min-width: 1367px) {
    .type-header {
        width: 76%;
    }
}

.remove-color:hover {
    color: #66615B !important;
}

.badge {
    position: absolute;
    top: -14px;
    right: -6px;
    padding: 3px 7px 5px 7px;
    border-radius: 50%;
    background-color: red;
    color: white;
}

.navbar-icon {
    margin-left: -50px !important;
}

.user-name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 120px;
    font-weight: 500;
    font-size: 14px;
    color: #333;
}

.dropdown-toggle-name::after {
    display: none !important;
}

@media (max-width: 991px) {
    .navbar-all-nav {
        flex-direction: row;
        margin-top: 30px;
    }
    .dropdown-icon {
        margin-top: 0px !important;
    }
}

.notification-red-badge {
    position: absolute;
    right: 5px;
    top: 5px;
    padding-left: 3px;
    padding-right: 3px;
    background: #f44336;
    text-align: center;
    margin: 0;
    font-size: 10px;
    color: white;
    font-weight: 600;
    border-radius: 30px;
    height: 18px;
    min-width: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(244, 67, 54, 0.4);
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
}

.notification-icon-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

</style>
